import { Page } from '@thoughtspot/visual-embed-sdk';
import { viewType } from '../types';

// API Endpoints
export const LIVEBOARD_ID = '0bfc1cc3-75a5-487d-82c3-45cc704437cb';
export const VIZ_ID = '243189d9-1a79-4762-8642-6f2189f617b1';
export const WORKSHEET_ID = '38399c50-02f1-4310-804b-214b81f25333';
export const SEARCH_METADATA_API_ENDPOINT = '/api/rest/2.0/metadata/search';
export const LIVEBOARD_METADATA_API_ENDPOINT = '/api/rest/2.0/metadata/list';

// Authentication
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const GET_AUTH_TOKEN = 'GET_AUTH_TOKEN';
export const TOKEN_TYPE = 'AUTH_TOKEN';
export const VALIDITY_TIME_IN_SEC = 3600;
export const TIMEOUT_MS = 10000;

// Variables
export const GET_RELEASE_VARIABLES = 'GET_RELEASE_VARIABLES';
export const RELEASE_VARIABLES_TYPE = 'RELEASE_VARIABLES';

// Host Configuration
export const TS_HOST = process.env.REACT_APP_TS_HOST || 'https://try-everywhere.thoughtspot.cloud';
export const PREAUTH_INFO = '/prism/preauth/info';

// Embed feature flags — spread onto each embed's view-config and reported to the AI
// service (environment.flags) for the active embed so it knows which capabilities are
// enabled. Keep each set to props the corresponding SDK embed actually accepts.
export const LIVEBOARD_FEATURE_FLAGS = {
  isLiveboardMasterpiecesEnabled: true,
  isLiveboardCompactHeaderEnabled: true,
  hideIrrelevantChipsInLiveboardTabs: true,
  coverAndFilterOptionInPDF: true,
  isEnhancedFilterInteractivityEnabled: true,
  isCentralizedLiveboardFilterUXEnabled: true,
};

export const APP_EMBED_FEATURE_FLAGS = {
  showPrimaryNavbar: true,
  ...LIVEBOARD_FEATURE_FLAGS,
};

export const SEARCH_EMBED_FEATURE_FLAGS = {
  dataPanelV2: true,
  collapseDataSources: false,
};

// viz renders inside a LiveboardEmbed and spotter sets no feature flags today;
// kept as explicit (empty) sets so flags can be added per embed in one place.
export const VIZ_EMBED_FEATURE_FLAGS = {};

export const SPOTTER_EMBED_FEATURE_FLAGS = {};

// Flags for the currently active embed, keyed by viewType.
export const EMBED_FEATURE_FLAGS_BY_VIEW: Record<viewType, Record<string, boolean>> = {
  home: APP_EMBED_FEATURE_FLAGS,
  liveboard: LIVEBOARD_FEATURE_FLAGS,
  viz: VIZ_EMBED_FEATURE_FLAGS,
  search: SEARCH_EMBED_FEATURE_FLAGS,
  spotter: SPOTTER_EMBED_FEATURE_FLAGS,
};

// UI Text
export const SELECT_SAVED_ANSWER_OR_DATA_SOURCE = 'Select Saved Answer or Data Source';
export const SELECT_A_SAVED_ANSWER = 'Select a Saved Answer';
export const SELECT_A_LIVEBOARD = 'Select a Liveboard';
export const SELECT_A_VISUALIZATION = 'Select a Visualization';
export const SET_ACTIVE_LEFT_NAVIGATION_ITEM = 'Set active left navigation item';
export const SELECT_A_COMPONENT = 'Select a Component';
export const SELECT_A_DATA_SOURCE = 'Select a Data Source';
export const THEME_BUILDER_TITLE = 'Theme Builder';
export const BACK_BUTTON_TEXT = 'Back';

// Component Selection Options
export const COMPONENT_FULL_APP_SELECTION_OPTIONS = [
  { id: Page.Home, label: 'Home', disabled: false },
  { id: Page.Search, label: 'Search', disabled: false },
  { id: Page.Data, label: 'Data', disabled: false },
  { id: Page.Answers, label: 'Answers', disabled: false },
  { id: Page.Liveboards, label: 'Liveboards', disabled: false },
  { id: Page.Monitor, label: 'Monitor', disabled: false },
];

export const COMPONENT_SELECTION_OPTIONS = [
  { id: 'answers', label: 'Answers', disabled: false },
  { id: 'datasource', label: 'Data Sources', disabled: false },
];

// Error Messages
export const AUTH_ERROR_MESSAGE = 'Authentication failed';
export const TOKEN_ERROR_MESSAGE = 'Failed to retrieve authentication token';
export const VARIABLES_ERROR_MESSAGE = 'Failed to fetch variables';
export const PREAUTH_ERROR_MESSAGE = 'Failed to retrieve preauth info';
